import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _get from 'lodash.get';
//import Video from 'components/Video';
import Player from 'components/LitePlayer/Player';
import { mute } from 'components/Video/utils';
import LoaderSpinner from 'components_v2/common/LoaderSpinner/LoaderSpinner';
import { fireGa4, fireGa4andGrx } from '../../../layouts/utils';
// import GameCard from '../GameCard/GameCard';
import s from './LocationGuesserGame.scss';
import {
  loadSyncUp,
  loadLocationGuesserStateFetch,
  loadLocationGuesserStateSave,
} from '../../../redux';

const LocationGuesserPlayer = props => {
  const {
    puzzleData,
    handlePlayerError,
    handleGameCallback,
    todaysGame,
    isMobile,
    gameId,
  } = props;
  if (!puzzleData || !puzzleData.slikeIdDesktop || !puzzleData.slikeIdMobile) {
    return '';
  }
  const videoRef = useRef(null);
  const conEl = 'lg';
  const [isMute, setMute] = useState(true);
  const [isPlay, setPlay] = useState(true);
  const [showLoader, setLoader] = useState(true);
  const [showControls, setShowControls] = useState(false);
  const timerRef = useRef(null);

  const hardPause = () => {
    if (document.visibilityState === 'hidden') {
      if (typeof handleGameCallback === 'function') {
        handleGameCallback();
        if (window && window.lwPlayer && window.lwPlayer.lg) {
          window.lwPlayer.lg.destroy();
          window.scrollTo({
            top: 0,
            behavior: 'smooth', // Adds a smooth scrolling effect
          });
        }
      }
    }
  };

  useEffect(() => {
    // Add visibility change event listener
    document.addEventListener('visibilitychange', hardPause);

    // Clean up event listener on component unmount
    return () => {
      document.removeEventListener('visibilitychange', hardPause);
    };
  }, []);

  useEffect(() => {
    const updatePlayState = () => {
      if (window?.lwPlayer?.lg?.cPlayer?.video) {
        const isPaused = window.lwPlayer.lg.cPlayer.video.paused;
        setPlay(!isPaused);
      }
    };

    const intervalId = setInterval(updatePlayState, 500);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play();
      if (window?.lwPlayer?.lg?.cPlayer?.video?.paused) {
        setPlay(false);
      } else {
        setPlay(true);
      }
      if (window?.lwPlayer?.lg?.cPlayer?.video?.muted) {
        setMute(true);
      } else {
        setMute(false);
      }
    }
  }, []);

  const handleMuteUmute = () => {
    if (!isMute) {
      setMute(true);
      mute(true, conEl);
    } else {
      setMute(false);
      mute(false, conEl);
    }
  };

  const handlePlayPause = () => {
    if (isPlay) {
      setPlay(false);
      if (window?.lwPlayer?.lg?.pause) {
        window.lwPlayer.lg.pause();
      }
      fireGa4andGrx(
        'pause',
        'user_click_games',
        'gameplay',
        'location_guesser',
        isMobile,
        gameId,
        '',
      );
    } else {
      setPlay(true);
      if (window?.lwPlayer?.lg?.play) {
        window.lwPlayer.lg.play();
      }
      fireGa4andGrx(
        'play',
        'user_click_games',
        'gameplay',
        'location_guesser',
        isMobile,
        gameId,
        '',
      );
    }
  };
  const handlePrevious = () => {
    if (window?.lwPlayer?.lg) {
      window.lwPlayer.lg.seek(-10, true);
    }
    setPlay(true);
  };
  const handleForward = () => {
    if (window?.lwPlayer?.lg) {
      window.lwPlayer.lg.seek(10, true);
    }
    setPlay(true);
  };
  const startOver = () => {
    if (window?.lwPlayer?.lg) {
      window.lwPlayer.lg.rePlay();
    }
  };

  const howToPlayPopup = () => {
    props.howtoPlaycheck('howtoplaylg');
  };

  // eslint-disable-next-line no-unused-vars
  const processVideoEvent = (args, web) => {
    try {
      const event = args && args[0];
      let state;
      switch (event) {
        case 'INIT':
          setLoader(false);
          break;
        default:
      }
      if (state) this.setState(state);
    } catch (error) {
      //
    }
  };

  const renderVideoPlayer = () => {
    const slikePlayerConfig = {
      autoplay: true,
      //videoClassName: container,
      //videoClassInner: s.player_container_bg,
      slikeId: props.isMobile
        ? puzzleData?.slikeIdMobile
        : puzzleData?.slikeIdDesktop,
      //msid: '115236123',
      playerContainerId: 'lg_player_id',
      isPrime: props.isPrime,
      allowDim: false,
      isVideoSkipAds: '1',
      videoInloop: '1',
      mute: true,
      sectionName: 'TOI Games - Location Guesser',
      source: 'TOI_GAMES',
      agency: 'TOI',
      titleStr: 'TOI Games - Location Guesser',
      shareUrl: '',
      headless: true,
      pageTpl: 'toigames',
      metakeywords: '',
      bl: '0',
      ui: { scale: 2 },
      outsideEventListener: (...args) => {
        processVideoEvent(args, true);
      },
      playerErrorCallback: () => {
        if (handlePlayerError && typeof handlePlayerError === 'function')
          handlePlayerError();
      },
    };
    const liteConfig = {
      ...slikePlayerConfig,
      divId: `lg_player_id`,
      globalRefId: 'lg',
      globalRefId_game: 'locationguesser',
      isFullPlayer: true,
    };
    return <Player {...liteConfig} />;
  };

  const handleMouseMove = () => {
    setShowControls(true);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setShowControls(false);
    }, 3000);
  };

  const handlBackButtonClick = () => {
    const { href, origin } = window.location;
    const todayPath = `${origin}/games/location-guesser/today`;
    const practicePath = `${origin}/games/location-guesser/practice`;
    if (href === todayPath) {
      // Redirect to /games
      window.location.href = `${origin}/games`;
    } else if (
      href.includes(`${origin}/games/location-guesser/`) &&
      !todaysGame
    ) {
      // Redirect to /games/location-guesser/practice
      window.location.href = practicePath;
    }
  };

  return (
    <>
      <div
        id="lg_player_id"
        style={{ height: '100vh' }}
        className={`${s.lgPlayer} lgPlayer`}
        onMouseMove={handleMouseMove}
      >
        {showLoader && <LoaderSpinner />}
        {renderVideoPlayer()}
      </div>
      <button
        className={`${s.borderBtn} ${s.backBtn}`}
        onClick={() => {
          handlBackButtonClick();
          fireGa4andGrx(
            'back',
            'user_click_games',
            'gameplay',
            'location_guesser',
            isMobile,
            gameId,
            '',
          );
        }}
      >
        <i className={`${s.locationGuesserSprite} ${s.backArrow}`} />
      </button>
      <div className={s.controls}>
        <button
          onClick={() => {
            howToPlayPopup();
            fireGa4andGrx(
              'how_to_play',
              'user_click_games',
              'gameplay',
              'location_guesser',
              isMobile,
              gameId,
              '',
            );
          }}
        >
          <i className={`${s.locationGuesserSprite} ${s.help}`} />
        </button>
        <button
          onClick={() => {
            startOver();
            fireGa4andGrx(
              'play_again',
              'user_click_games',
              'gameplay',
              'location_guesser',
              isMobile,
              gameId,
              '',
            );
          }}
        >
          <i className={`${s.locationGuesserSprite} ${s.replay}`} />
        </button>
        <button
          onClick={() => {
            handleMuteUmute();
            fireGa4andGrx(
              'audio',
              'user_click_games',
              'gameplay',
              'location_guesser',
              isMobile,
              gameId,
              isMute ? 'mute' : 'unmute',
            );
          }}
        >
          <i
            className={`${s.locationGuesserSprite} ${
              isMute ? s.mute : s.unMute
            }`}
          />
        </button>
      </div>
      {showControls && (
        <>
          <button
            className={`${s.borderBtn} ${s.previous} ${s.whiteShadow}`}
            onClick={() => {
              handlePrevious();
            }}
          >
            <i className={`${s.locationGuesserSprite} ${s.remind}`} />
            <span className={s.time}>10s</span>
          </button>
          <button
            className={`${s.borderBtn} ${s.playPause}`}
            onClick={() => {
              handlePlayPause();
            }}
          >
            <i
              className={`${s.locationGuesserSprite} ${
                isPlay ? s.pause : s.play
              }  `}
            />
          </button>
          <button
            className={`${s.borderBtn} ${s.next} ${s.whiteShadow}`}
            onClick={() => {
              handleForward();
            }}
          >
            <i className={`${s.locationGuesserSprite} ${s.forward}`} />
            <span className={s.time}>10s</span>
          </button>
        </>
      )}
    </>
  );
};

LocationGuesserPlayer.propTypes = {
  isMobile: PropTypes.bool,
  puzzleAPI: PropTypes.shape({}),
  isToday: PropTypes.bool,
  gameId: PropTypes.string,
};

LocationGuesserPlayer.defaultProps = {
  isMobile: false,
  puzzleAPI: {},
  isToday: false,
  gameId: '',
};

const mapStateToProps = state => ({
  isPrime: state.isPrime,
  isMobile: state.isMobile,
  isFrmapp: state.isFrmapp,
  puzzleAPI: _get(state, 'toigames.puzzledata', ''),
  gamesmetawidget: _get(state, 'toigames.gamesmetawidget', {}),
  userData: state.login.userData,
  todaysGame: _get(state, 'toigames.puzzledata.todaysGame', ''),
  apiConfigData: _get(
    state,
    'toigames.gamesconfig.gameCategories.LocationGuesser',
    '',
  ),
  stateData: state.toigames && state.toigames.LocationGuesserstate,
});

const mapDispatchToProps = dispatch => ({
  loadSyncUp: params => {
    dispatch(loadSyncUp(params));
  },
  loadLocationGuesserStateFetch: params => {
    dispatch(loadLocationGuesserStateFetch(params));
  },
  loadLocationGuesserStateSave: params => {
    dispatch(loadLocationGuesserStateSave(params));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(
  LocationGuesserPlayer,
);
